import { useEffect } from 'react';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { OrdersList } from '@features/order/orders-list';
import { useNavigate } from 'react-router-dom';
import { OrderCardProps } from '@ui/order/order-card';
import { useOrderService } from '../../entites/order/use-order.service.ts';
import { OrderUti } from '@shared/const/order.ts';
import { BreadcrumbItem, Breadcrumbs } from '@heroui/react';
import { Home2 } from 'iconsax-react';
import { UserAuthorizationCard } from '@features/profile/user-authorization-card';
import { ActiveOrders } from '@features/order/active-orders';
import { ShortCuts } from '@features/profile/short-cuts';
import { UserExitButton } from '@features/profile/ui/user-exit-button.tsx';

export function useOrdersList() {
  const navigate = useNavigate();
  const service = useOrderService({});

  const array: (OrderCardProps | undefined)[] = new Array(5).fill(0).map(() => {
    return {
      isLoading: true,
      images: [undefined, undefined, undefined, undefined],
    };
  });

  const data: (OrderCardProps | undefined)[] =
    service.data?.data.map((item) => {
      return {
        number: `# ${item.id}`,
        status: OrderUti.status(item.status),
        total: `${item.total_price} ₸`,
        images: item.items.map((product) => product.product.main_photo),
        onPress: () => navigate(`/orders/${item.id}`),
      };
    }) || [];

  const dataDesktop: (OrderCardProps | undefined)[] =
    service.data?.data.map((item) => {
      return {
        number: `# ${item.id}`,
        variant: 'secondary',
        status: OrderUti.status(item.status),
        total: `${item.total_price} ₸`,
        images: item.items.map((product) => product.product.main_photo),
        onPress: () => navigate(`/orders/${item.id}`),
      };
    }) || [];

  return {
    data: service.data ? data : array,
    dataDesktop: service.data ? dataDesktop : array,
  };
}

export const OrdersPage = () => {
  const set = useNavbar();

  const { data, dataDesktop } = useOrdersList();

  useEffect(() => {
    set.orders();
  }, []);

  return (
    <>
      <div className="hidden lg:block container max-w-7xl mx-auto">
        <div className="hidden lg:block mt-12">
          <Breadcrumbs>
            <BreadcrumbItem href="/">
              <Home2 size="24" color="#9CA5AC" />
            </BreadcrumbItem>
            <BreadcrumbItem color="primary">Профиль</BreadcrumbItem>
          </Breadcrumbs>
        </div>

        <div className="mt-6">
          <h1 className="hidden lg:inline text-4xl text-[#222222] font-bold">
            Профиль
          </h1>
        </div>
      </div>

      <div className="hidden lg:flex flex-row container max-w-7xl mx-auto mt-12 pb-32 gap-x-12">
        <div className="w-[375px] flex flex-col">
          <UserAuthorizationCard />

          <ActiveOrders />

          <ShortCuts />

          <UserExitButton />
        </div>

        <div className="flex-grow max-w-[850px]">
          <p className="text-2xl font-semibold text-[#222222] pb-9">
            История заказов
          </p>

          <OrdersList isDivided={false} items={dataDesktop} />
        </div>
      </div>

      <div className="lg:hidden">
        <OrdersList items={data} />
      </div>
    </>
  );
};
